import React, { Component } from 'react'
import { Switch, Route, withRouter } from 'react-router-dom'
import * as Sentry from '@sentry/browser'

import {
  Dashboard,
  // messageplus specific
  EmployeeList,
  EmployeeDetail,
  EmployeeOverview,
  EmployerGroupEmployeeOverview,
  EmployerSMS,
  EmployerGroupSMS,
  EmployerBulkMessage,
  EmployerWhatsApp,
  EmployerRelatedMessages,
  EmployerBulkSMSAudience,
  Requests
} from './'

import {
  PrivateRouteWithPermission
} from '../auth'

import { NUMBER_CHANGE_ACTIVE } from '../constants'

const FourOhFour = ({ pathName }) => {
  Sentry.captureMessage(`Page not found for ${pathName}`, 'error')
  return (
    <div>
      <h2>Page Not Found</h2>
    </div>
  )
}


export class Main extends Component {
  render() {
    return (
      <div className='stage-main slds-size_1-of-1' style={{ position: 'absolute', top: 80, overflowX: 'unset' }}>
        <Switch>
          {/* <PrivateRoute exact path='/:id' component={ObjectRedirect} /> */}
          <PrivateRouteWithPermission exact path='/dashboard' responsibility='messageplus_user' component={Dashboard} />

          {/* employer-level specific routes */}
          <PrivateRouteWithPermission exact path='/employer/:employerId/employees' responsibility='messageplus_user' model='employer' component={EmployeeList} />
          <PrivateRouteWithPermission exact path='/employer/:employerId/employees/overview' responsibility='messageplus_user' model='employer' component={EmployeeOverview} />
          {NUMBER_CHANGE_ACTIVE && <PrivateRouteWithPermission exact path='/employer/:employerId/employees/requests' responsibility='messageplus_user' model='employer' component={Requests} />}
          <PrivateRouteWithPermission path='/employer/:employerId/employees/:identityId' responsibility='messageplus_user' model='employer' component={EmployeeDetail} />
          <PrivateRouteWithPermission exact path='/employer/:employerId/communications/bulk' responsibility='messageplus_user' model='employer' component={EmployerSMS} />} />
          <PrivateRouteWithPermission exact path='/employer/:employerId/communications/bulk/:messageId' responsibility='messageplus_user' model='employer' component={EmployerBulkMessage} />} />
          <PrivateRouteWithPermission exact path='/employer/:employerId/communications/bulk/audience/:audienceId' responsibility='messageplus_user' model='employer' component={EmployerBulkSMSAudience} />} />
          <PrivateRouteWithPermission exact path='/employer/:employerId/communications/whatsapp' responsibility='messageplus_user' model='employer' component={EmployerWhatsApp} />} />
          <PrivateRouteWithPermission exact path='/employer/:employerId/communications/messages/:messageId' responsibility='messageplus_user' model='employer' component={EmployerRelatedMessages} />} />
          {/* employergroup-level specific routes */}
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/employees' responsibility='messageplus_user' model='employergroup' component={EmployeeList} />
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/employees/overview' responsibility='messageplus_user' model='employergroup' component={EmployerGroupEmployeeOverview} />
          <PrivateRouteWithPermission path='/group/:employerGroupId/employees/:identityId' responsibility='messageplus_user' model='employergroup' component={EmployeeDetail} />
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/communications/bulk' responsibility='messageplus_user' model='employergroup' component={EmployerGroupSMS} />} />
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/communications/bulk/:messageId' responsibility='messageplus_user' model='employergroup' component={EmployerBulkMessage} />} />
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/communications/bulk/audience/:audienceId' responsibility='messageplus_user' model='employergroup' component={EmployerBulkSMSAudience} />} />
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/communications/whatsapp' responsibility='messageplus_user' model='employergroup' component={EmployerWhatsApp} />} />
          <PrivateRouteWithPermission exact path='/group/:employerGroupId/communications/messages/:messageId' responsibility='messageplus_user' model='employergroup' component={EmployerRelatedMessages} />} />
          {/* ----------------------------------------------*/}

          <Route render={() => <FourOhFour pathName={this.props.location.pathname}/>} />
        </Switch>
      </div>
    )
  }
}

export default withRouter(Main)



// WEBPACK FOOTER //
// ./src/containers/Main.js